import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../../components/sidebar";
import { useNavigate, useOutletContext } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.scss";
import PdfReportIcon from "../../../icons/PdfReportIcon";
import ExcelReportIcon from "../../../icons/ExcelReportIcon";
import CsvReportIcon from "../../../icons/CsvReportIcon";
import TxfReportIcon from "../../../icons/TxfReportIcon";
import NonRealEstateReportIcon from "../../../icons/NonRealEstateReportIcon";
import FIleWhiteIcon from "../../../icons/FIleWhiteIcon";
import CircleGreenTick from "../../../icons/CircleGreenTick";
import { useDispatch } from "react-redux";
import { all_routes } from "../../router/all_routes";
import { Button } from "react-bootstrap";
import { FiArrowUpRight } from "react-icons/fi";
import { YEARS_LIST } from "../../../constants/years";
import { toast } from "react-toastify";
import { generateNonRealReport } from "../../../core/data/redux/report/_reportAction";
import DocReportIcon from "../../../icons/DocReportIcon";

const exportOptions = [
  {
    id: "pdf",
    label: "PDF (IRS-Ready)",
    description: "Professional formatted report for IRS submission",
    icon: <PdfReportIcon />,
  },
  {
    id: "docx",
    label: "Docx (Detailed)",
    description: "Spreadsheet with formulas and detailed calculations",
    icon: <DocReportIcon />,
  },
  // {
  //   id: "csv",
  //   label: "CSV (Raw Data)",
  //   description: "Raw data export for further analysis",
  //   icon: <CsvReportIcon />,
  // },
  // {
  //   id: "txf",
  //   label: "Tax Software (.txf)",
  //   description: "Import directly into tax preparation software",
  //   icon: <TxfReportIcon />,
  // },
];

const NonRealReports: React.FC = () => {
  const { isSidebarOpen } = useOutletContext<{
    isSidebarOpen: boolean;
    onToggleSidebar: () => void;
  }>();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const routes = all_routes;

  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState<string | null>(null);
  const [selectedExportFormat, setSelectedExportFormat] = useState<
    string | null
  >(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [detailLevel, setDetailLevel] = useState<string | null>(null);
  const [participationLevel, setParticipationLevel] = useState<string | null>(
    null
  );
  const [isGenerating, setIsGenerating] = useState(false);

  const [errors, setErrors] = useState({
    year: "",
    exportFormat: "",
    detailLevel: "",
    participationLevel: "",
  });
  const dropdownRef = useRef<HTMLDivElement>(null);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Generate & Download report handler
  const handleGenerateReport = async () => {
    const newErrors = {
      year: selectedYear ? "" : "Please select a reporting year",
      exportFormat: selectedExportFormat
        ? ""
        : "Please select an export format",
      detailLevel: detailLevel ? "" : "Please select detail level",
      participationLevel: participationLevel
        ? ""
        : "Please select participation level",
    };
    setErrors(newErrors);

    if (newErrors.year || newErrors.exportFormat) {
      return;
    }

    setIsGenerating(true);
    try {
      // Get local timezone string
      const payload = {
        year: selectedYear,
        non_real_detail_level: detailLevel || "",
        participation_level: participationLevel || "",
        file_type: selectedExportFormat,
        category: "non_real_estate",
        timezone,
      };

      const response = await dispatch(generateNonRealReport(payload));

      if (response?.payload?.success) {
        const fileUrl = response.payload.data?.file;
        if (fileUrl) {
          // Fetch file as Blob to force download
          const fileResponse = await fetch(fileUrl);
          const blob = await fileResponse.blob();
          const blobUrl = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = `report_${selectedYear}.${selectedExportFormat}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          window.URL.revokeObjectURL(blobUrl); // clean up
          toast.success("Report downloaded successfully.");
        } else {
          toast.success("Report generated successfully.");
        }
      } else {
        // toast.error("Failed to generate report. Please try again.");
      }
    } catch (error) {
      console.error("Error generating report:", error);
      toast.error("An error occurred while generating the report.");
    } finally {
      setIsGenerating(false);
    }
  };

  const handlePreviewReport = async () => {
    const newErrors = {
      year: selectedYear ? "" : "Please select a reporting year",
      exportFormat: selectedExportFormat
        ? ""
        : "Please select an export format",
      detailLevel: detailLevel ? "" : "Please select detail level",
      participationLevel: participationLevel
        ? ""
        : "Please select participation level",
    };
    setErrors(newErrors);

    if (newErrors.year || newErrors.exportFormat) {
      return;
    }

    const payload = {
      year: selectedYear,
      non_real_detail_level: detailLevel || "",
      participation_level: participationLevel || "",
      file_type: selectedExportFormat,
      category: "non_real_estate",
      timezone
    };

    try {
      const response = await dispatch(generateNonRealReport(payload));
      if (response?.payload?.success) {
        const fileUrl = response.payload.data?.file;
        if (fileUrl) {
          window.open(fileUrl, "_blank"); // open PDF preview in new tab
        } else {
          toast.error("No PDF file available for preview.");
        }
      } else {
        // toast.error("Failed to generate preview report. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while generating the preview.");
    }
  };


  return (
    <div className="layout ">
      <Sidebar isOpen={isSidebarOpen} />

      <main className="content">

        <div className="profileSettings non-real-estate report-page-section">
          <div className=" rounded report-page-inner">
            <div className="export-option-content mb-5">
              <div className="export-option-icon">
                <NonRealEstateReportIcon />

                <div className="export-option-label">
                  Non-Real Estate Reports
                </div>
              </div>

              <Button
                className="generate-report-button"
                onClick={() => navigate(routes.nonRealGeneratedReports)}
              >
                Generated Reports <FiArrowUpRight />
              </Button>
            </div>

            {/*  Choose Reporting Year */}
            <div className="row g-3 mb-3">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <label className="form-label">Choose Reporting Year</label>

                <div className="dropdown" id="reporting-year-dropdown">
                  <button
                    className="form-select d-flex justify-content-between align-items-center bg-light form-control commonInput"
                    onClick={() => setIsYearDropdownOpen(!isYearDropdownOpen)}
                    type="button"
                  >
                    {selectedYear || "Choose Reporting Year"}
                    <i
                      className={`bi bi-chevron-${isYearDropdownOpen ? "up" : "down"
                        }`}
                    />
                  </button>

                  {isYearDropdownOpen && (
                    <div
                      className="dropdown-menu show w-100 shadow-sm mt-1 bg-light p-0"
                      style={{ maxHeight: "400px", overflowY: "auto" }}
                    >
                      {YEARS_LIST?.map((year) => (
                        <div
                          key={year}
                          className="d-flex justify-content-between align-items-center px-3 py-3 border-bottom"
                          onClick={() => {
                            setSelectedYear(year.toString());
                            setIsYearDropdownOpen(false);
                            setErrors((prev) => ({ ...prev, year: "" }));
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <span>{year}</span>
                          <input
                            type="radio"
                            name="reportingYear"
                            className="form-check-input"
                            checked={selectedYear === year.toString()}
                            readOnly
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {errors.year && (
                    <div className="text-danger mt-1 small">{errors.year}</div>
                  )}
                </div>
              </div>
            </div>

            {/* Configure Your Report */}
            <div className="row g-3 mb-3">
              <div className="mb-0 mt-4">
                <h3 className="mb-0">Configure Your Report</h3>
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                <label className="form-label">Detail Level</label>
                <select
                  className="form-select form-control commonInput bg-light"
                  value={detailLevel || ""}
                  onChange={(e) => {
                    const value = e.target.value || null;
                    setDetailLevel(value);
                    if (errors.detailLevel && value) {
                      setErrors((prev) => ({ ...prev, detailLevel: "" }));
                    }
                  }}
                >
                  <option value="" disabled selected hidden>
                    Choose Detail Level
                  </option>
                  <option value="summary">Summary Only</option>
                  <option value="monthly">With Monthly Breakdown </option>
                  <option value="detailed">With Detailed Entries</option>
                </select>
                {errors.detailLevel && (
                  <div className="text-danger mt-1 small">
                    {errors.detailLevel}
                  </div>
                )}
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                <label className="form-label">Participation Level</label>
                <select
                  className="form-select form-control commonInput bg-light"
                  value={participationLevel || ""}
                  onChange={(e) => {
                    const value = e.target.value || null;
                    setParticipationLevel(value);
                    if (errors.participationLevel && value) {
                      setErrors((prev) => ({
                        ...prev,
                        participationLevel: "",
                      }));
                    }
                  }}
                >
                  <option value="" disabled selected hidden>
                    choose Participation Level
                  </option>
                  <option value="all">All (Active + Passive) </option>
                  <option value="active">Active Only</option>
                  <option value="passive">Passive Only</option>
                </select>
                {errors.participationLevel && (
                  <div className="text-danger mt-1 small">
                    {errors.participationLevel}
                  </div>
                )}
              </div>
            </div>

            {/* --- Choose Export Format --- */}
            <div className="export-format">
              <div className=" d-flex align-items-center gap-3 mb-4">
                <h3 className="mb-0">Choose Export Format</h3>
              </div>
              <div className="row mt-3 g-3 bg-white border-line align-items-stretch">
                {exportOptions.map(({ id, label, description, icon }) => (
                  <div
                    key={id}
                    className="col-12 col-md-12 col-lg-6 col-xlg-6 mb-4"
                  >
                    <div
                      className={`export-option-card h-100 ${selectedExportFormat === id ? "selected" : ""}`}
                      onClick={() => {
                        setSelectedExportFormat(id);
                        setErrors((prev) => ({ ...prev, exportFormat: "" }));
                      }}
                    >
                      <div className="export-option-content">
                        <div className="export-option-icon">{icon}</div>
                        <div>
                          <div className="export-option-label">{label}</div>
                          <div className="export-option-description">
                            {description}
                          </div>
                        </div>
                      </div>

                      <input
                        type="checkbox"
                        name="exportFormat"
                        checked={selectedExportFormat === id}
                        onChange={() => {
                          setSelectedExportFormat(id);
                          setErrors((prev) => ({ ...prev, exportFormat: "" }));
                        }}
                        className="export-option-radio"
                      />
                    </div>
                  </div>
                ))}
              </div>
              {errors.exportFormat && (
                <div className="text-danger mt-1 small">
                  {errors.exportFormat}
                </div>
              )}
            </div>
            {/* --- Choose Export Format End --- */}

            {/* --- Choose Export Format 2 --- */}
            <div className="export-format">
              <div className=" d-flex align-items-center gap-3 mb-4">
                <h3 className="mb-0">Generate Your Report</h3>
              </div>
              <div className="row mt-4 bg-white ">
                <div className="delivery-method-section  p-3 form-control commonInput">
                  <div className="d-flex gap-3 flex-wrap">
                    <button
                      className="btn  d-flex align-items-center gap-2 px-3 py-2 text-white"
                      onClick={handlePreviewReport}
                      disabled={selectedExportFormat !== "pdf"} // enable only for PDF
                    >
                      <FIleWhiteIcon />
                      Preview Report
                    </button>

                    <button
                      className="btn btn-2  d-flex align-items-center gap-2 px-3 py-2 text-white"
                      onClick={handleGenerateReport}
                    >
                      <FIleWhiteIcon />
                      Generate & Download
                    </button>
                  </div>

                  <div className="alert bg-white mt-3 d-flex align-items-top gap-3 form-control commonInput p-4">
                    <CircleGreenTick />
                    <span>
                      <p className="mb-2">
                        <strong>IRS-Compliant Documentation Ready</strong>
                      </p>
                      <p>
                        Your report will include digital signatures, audit
                        trails, and all required documentation for real estate
                        professional status.
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* --- Choose Export Format End 2 --- */}
          </div>
        </div>

      </main>
    </div>
  );
};

export default NonRealReports;
